import { render, staticRenderFns } from "./ViewAllMaterials.vue?vue&type=template&id=63015128&scoped=true"
import script from "./ViewAllMaterials.vue?vue&type=script&lang=js"
export * from "./ViewAllMaterials.vue?vue&type=script&lang=js"
import style0 from "./ViewAllMaterials.vue?vue&type=style&index=0&id=63015128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63015128",
  null
  
)

export default component.exports